import ScrollMonitor from "./partial/scrollMonitor";
var scrollShow = new ScrollMonitor.Scrolload($(".s_s"), "show");

import Top from "./partial/top";

import Accordion from "./partial/accordion";
import Duplicate from "./partial/duplicate";
import Modal from "./partial/modal";
import OrderBuild from "./partial/order_build";
import OrderCategory from "./partial/order_category";
import OrderChoose_image from "./partial/order_choose_image";
import OrderInformation from "./partial/order_information";
import OrderMainCopy from "./partial/order_mainCopy";
import OrderPurchase from "./partial/order_purchase";
import OrderService from "./partial/order_service";
import SetThumbImage from "./partial/set_thumb_image";
import Tab from "./partial/tab";
import Utility from "./partial/utility";

var win = window;
var $win = $(window);
win.requestAnimationFrame = win.requestAnimationFrame || win.mozRequestAnimationFrame || win.webkitRequestAnimationFrame || win.msRequestAnimationFrame || function(cb) {
  setTimeout(cb, 17);
};

var getW = () => {
  return $win.width();
};
var getH = () => {
  return $win.height();
};
var getWinW = () => {
  return $win.width();
};
var getWinH = () => {
  return $win.height();
};
var getScrollTop = () => {
  return $win.scrollTop();
};
var getOffset = _ele => {
  return $(_ele).offset().top;
};

var winW = getW();
var winH = getH();
var winS = getScrollTop();
var isSp;

if ($(".device-sp").length > 0) {
  isSp = true;
} else {
  isSp = false;
}

function isSP() {
  if ($(window).width() < 750) {
    return true;
  } else {
    return false;
  }
}

var userAgent = window.navigator.userAgent.toLowerCase();

if (userAgent.indexOf("trident") != -1) {
  var isIE11 = true;
} else {
  var isIE11 = false;
}

// トップページ
if ($(".page-top .header").length > 0) {
  var isHome = true;
  var sm = new ScrollMonitor.ScrollMonitor(".page-top .header", "top", 500, isHome);
  var tfd = new Top.TopFeatureDemo();
} else {
  var isHome = false;
}

if ($("#js-fixed-bottom").length > 0) {
  var sm = new ScrollMonitor.ScrollMonitor("#js-fixed-bottom", "top", 380, isHome);
  var isFixedbottom = true;
} else {
  var isFixedbottom = false;
}

// -----------------------------------------
// ロード完了時に実行

$(window).on("load", function(e) {
  $(".wrapper").addClass("loaded");

  setTimeout(function() {
    scrollShow.init();
    render();
  }, 1300);
});

if ($("#js-order-build").length > 0) {
  var buildImages = new BuildImage(".list-sample__item");
}

if ($("#js-order-choose-image").length > 0) {
  var chooseImage = new ChooseImage();
}

// -----------------------------------------
// フレーム監視

function render() {
  if (scrolling) {
    scrollEvent();
    scrollShow.checkScroll();
  }
  requestAnimationFrame(render);
}

var resizeTimer = false;

$win.resize(function() {
  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(function() {
    var ww = getW();
    if (winW != ww) {
      resizeEvent();
      winW = ww;
    }
  }, 50);
});

var scrolling = false;
var scrollTimer = false;
$win.scroll(function() {
  scrolling = true;

  if (scrollTimer !== false) {
    clearTimeout(scrollTimer);
  }
  scrollTimer = setTimeout(function() {
    scrolling = false;

    //リサイズ時に実行する処理
  }, 200);
});

// -----------------------------------------
// リサイズ時に実行

function resizeEvent() {
  winW = getW();
  winH = getH();

  if (isHome) {
    sm.resize();
  }
}

// -----------------------------------------
// スクロール時に実行

function scrollEvent() {
  winS = getScrollTop();
  if (isHome) {
    sm.check();
  }
  if (isFixedbottom) {
    sm.check();
  }
}

import "../sass/style.scss";
